import { IPcr } from '../../../features/pcr/store/pcr.types'
import Logger from '../../../services/logger.service'
import { moveElementToPath } from '../../object.util'

export const moveInitiateIvGuage = (pcr: IPcr): IPcr => {
  try {
    if (pcr.patient?.initiateIvStateList && pcr.patient.initiateIvStateList.length > 0) {
      pcr.patient.initiateIvStateList.forEach((ivState) => {
        moveElementToPath(ivState, 'gauge', 'size')
      })
    }
    return pcr
  } catch (error) {
    Logger.error(`Error executing schema upgrade rule moveInitiateIvGuage ${error}`)
    throw error
  }
}
